module.exports = __webpack_public_path__ + "static/media/taizhangliucheng.a5bf4210.png";